import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBallRoomList, getBallroomImageContent } from "./template_slice";
import {
  Button,
  ErrorMsg,
  GetFormData,
  Loader,
  ValidateForm,
  checkAccess,
} from "../../Util/common";
import { KendoTreeTable } from "../../Kendo/kendo_treetable";
import { baseURL, post } from "../../Util/axios_helper";
import { KendoEditor } from "../../Kendo/kendo_editor";
import { KendoLoader } from "../../Kendo/kendo_loader";

export const BallroomImage = ({ selTab }) => {
  const dispatch = useDispatch();
  const { ballrooms, ballroomsLoaded, imageContent, imageContentLoaded } =
    useSelector((state) => state.emailTemplate);
  const [error, setError] = useState({});
  const [title, setTitle] = useState("");
  const [Loading, setLoading] = useState(false);
  const columns = [
    {
      field: "BallroomId",
      hidden: true,
    },
    {
      field: "BallRoomName",
      title: "Ballroom",
    },
  ];
  const childColumn = [
    {
      field: "TimeStamp",
      hidden: true,
    },
    {
      field: "TypeId",
      hidden: true,
    },
    {
      field: "TypeName",
      title: "Event Type",
    },
  ];

  useEffect(() => {
    if (selTab == 3) {
      dispatch(getBallRoomList());
    }
  }, [selTab]);

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const onEditClick = (e) => {
    let modalTitle = ` ${e.parent.BallRoomName} - ${e.child.TypeName}`;
    setError({});
    setTitle(modalTitle);
    dispatch(
      getBallroomImageContent({
        eventId: e.child.TypeId,
        ballroomId: e.parent.BallroomId,
      })
    );
    $("#model-ballroom-image").modal("show");
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    var err = ValidateForm(e);
    if (err) {
      setError(err);
    } else {
      setLoading(true);
      let data = GetFormData(e);
      await post(
        "EmailTemplate/SaveBallroomEventImage",
        data,
        true,
        false,
        false,
        true
      );
      setLoading(false);
      $("#model-ballroom-image").modal("hide");
    }
  };

  if (!ballroomsLoaded) {
    return <Loader />;
  }
  return (
    <>
      <KendoTreeTable
        name={"BallroomImages"}
        parentTableColumns={columns}
        parentTableData={ballrooms}
        childTableUrl={baseURL + "Configuration/GetEventTypesForBallroomImages"}
        childTableColumns={childColumn}
        showChildOptions={
          !checkAccess("EMAILCONFIGCREATE") || checkAccess("EMAILCONFIGEDIT")
        }
        showChildDelete={false}
        onChildEditClick={onEditClick}
        showChildSearch={true}
      />
      {/* <!--Modal--> */}
      <div
        className="modal custom-modal fade"
        id="model-ballroom-image"
        role="dialog"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-xl"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {imageContentLoaded ? (
                <form id="form-ballroom-image" onSubmit={onSubmit}>
                  <input
                    type="hidden"
                    name={"BallroomEventImageId"}
                    value={imageContent.BallroomEventImageId || 0}
                  />
                  <input
                    type="hidden"
                    name={"EventId"}
                    value={imageContent.EventId || 0}
                  />
                  <input
                    type="hidden"
                    name={"BallroomId"}
                    value={imageContent.BallroomId || 0}
                  />
                  <KendoEditor
                    name={"ImageContent"}
                    imageBrowser={{
                      enable: true,
                      read: baseURL + "EmailTemplate/GetImages",
                      upload: baseURL + "EmailTemplate/UploadImage",
                      delete: baseURL + "EmailTemplate/DeleteImage",
                      image: baseURL + "EmailTemplate/GetImage?path={0}",
                      thumbnail: baseURL + "EmailTemplate/GetThumbnail",
                    }}
                    required={true}
                    value={imageContent.ImageContent || ""}
                    onValidate={onValidation}
                    height={"55vh"}
                    createLink={false}
                    unlink={false}
                  />
                  {error.ImageContent && <ErrorMsg text={"*required"} />}
                  {Loading ? (
                    <KendoLoader className="d-flex justify-content-end align-items-center" />
                  ) : (
                    <div className="text-end btn-mt">
                      <Button
                        name={"Cancel"}
                        isCancelButton={true}
                        id="ballroom-ballmap-cancel"
                        dataBsDismiss={"modal"}
                      />
                      <Button name={"Save"} />
                    </div>
                  )}
                </form>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <!--Modal--> */}
    </>
  );
};
